/**
 * This file is the single source of truth for all tracking-events of this zone.
 * All events MUST be included here and the custom-attributes/dynamic data can be overridden
 * whenever necessary in the place of usage.
 *
 * e.g.:https://gitlab.com/raisin-global/raisin-gmbh/banking/raisin-frontend/-/merge_requests/2428
 */
export const EVENTS = {
    LOGOUT_SUCCEEDED: {
        eventName: 'logout-succeeded',
        object: 'logout',
        action: 'succeeded',
        description: 'logout-succeeded on the logout-countdown inside customer-portal',
        portal: 'customer-portal',
        boundedContext: 'strong-customer-auth',
        zone: 'customer-portal',
        component: 'logout-countdown',
    },
    REFRESH_TOKEN_EXPIRED: {
        eventName: 'session-refresh-token-expired',
        object: 'session-refresh-token',
        action: 'expired',
        description: 'session-refresh-token-expired on the logout-countdown inside customer-portal',
        portal: 'customer-portal',
        boundedContext: 'customer-advisory',
        zone: 'customer-portal',
        component: 'logout-countdown',
    },
    REFRESH_TOKEN_FAILED: {
        eventName: 'session-refresh-token-failed',
        object: 'session-refresh-token',
        action: 'failed',
        description: 'session-refresh-token-failed on the logout-countdown inside customer-portal',
        portal: 'customer-portal',
        boundedContext: 'customer-advisory',
        zone: 'customer-portal',
        component: 'logout-countdown',
    },
    REFRESH_TOKEN_SUCCEEDED: {
        eventName: 'session-refresh-token-succeeded',
        object: 'session-refresh-token',
        action: 'succeeded',
        description: 'session-refresh-token-succeeded on the logout-countdown',
        portal: 'customer-portal',
        boundedContext: 'customer-advisory',
        zone: 'customer-portal',
        component: 'logout-countdown',
    },
};
export const createLogOutSucceededEvent = ({ zone }) => (Object.assign(Object.assign({}, EVENTS.LOGOUT_SUCCEEDED), { zone: zone !== null && zone !== void 0 ? zone : 'customer-portal' }));
//# sourceMappingURL=index.js.map